import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export type WhatToCountKind = "income" | "expenses";

export const useWhatToCountContent = (kind: WhatToCountKind) => {
	const { tObject } = useResource();

	return tObject(
		kind === "income"
			? Resources.Finances.WhatToCount.Income
			: Resources.Finances.WhatToCount.Expenses,
	);
};
